import { render } from "./InstantServices.vue?vue&type=template&id=a53ea7b6"
import script from "./InstantServices.vue?vue&type=script&lang=js"
export * from "./InstantServices.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__